import { Routes, Route, Navigate } from 'react-router';
import { SalesLayoutWrapper } from './components/SalesLayoutWrapper';
import SalesDashboard from './pages/SalesDashboard';
import SalesLeadsPage from './pages/SalesLeadsPage';
import SalesMyLeadsPage from './pages/SalesMyLeadsPage';
import SalesAddLeadPage from './pages/SalesAddLeadPage';
import SalesAddCustomerPage from './pages/SalesAddCustomerPage';
import SalesLeadDetailPage from './pages/SalesLeadDetailPage';
import SalesConvertHandoff from './pages/SalesConvertHandoff';
import SalesCustomersPage from './pages/SalesCustomersPage';
import SalesAgentsPage from './pages/SalesAgentsPage';
import SalesAgentDetailPage from './pages/SalesAgentDetailPage';
import SalesCompaniesPage from './pages/SalesCompaniesPage';
import SalesCompanyCommissionPage from './pages/SalesCompanyCommissionPage';
import SalesCommissionPage from './pages/SalesCommissionPage';
import SalesQuotationsPage from './pages/SalesQuotationsPage';
import SalesImportPage from './pages/SalesImportPage';
import SalesProfilePage from './pages/SalesProfilePage';

/**
 * SalesRouter — route tree for /sales/*. Mounted by App.tsx behind a
 * SalesRoute guard (which lets in sales staff + admin via staff_profile.role).
 */
export function SalesRouter() {
  return (
    <Routes>
      <Route element={<SalesLayoutWrapper />}>
        <Route index element={<SalesDashboard />} />
        <Route path="leads" element={<SalesLeadsPage />} />
        <Route path="my-leads" element={<SalesMyLeadsPage />} />
        <Route path="leads/new" element={<SalesAddLeadPage />} />
        <Route path="leads/:id" element={<SalesLeadDetailPage />} />
        <Route path="leads/:id/convert" element={<SalesConvertHandoff />} />
        <Route path="quotations" element={<SalesQuotationsPage />} />
        <Route path="customers" element={<SalesCustomersPage />} />
        <Route path="customers/new" element={<SalesAddCustomerPage />} />
        <Route path="agents" element={<SalesAgentsPage />} />
        <Route path="agents/:id" element={<SalesAgentDetailPage />} />
        <Route path="companies" element={<SalesCompaniesPage />} />
        <Route path="companies/:id" element={<SalesCompanyCommissionPage />} />
        <Route path="commission" element={<SalesCommissionPage />} />
        <Route path="import" element={<SalesImportPage />} />
        <Route path="profile" element={<SalesProfilePage />} />
        <Route path="*" element={<Navigate to="/sales" replace />} />
      </Route>
    </Routes>
  );
}
